<div class="card">
    @if (allowedAdditionalData) {
        <div class="card-header">
            @if (additionalData.length > 0) {
                <button
                    class="btn btn-sm btn-primary mr-2"
                    [disabled]="!allowedAdditionalData"
                    (click)="enableAdditionalDataEdit()">
                    <fa-icon [icon]="['fas', 'pen']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Edit' | translate }}
                </button>
            }
            @if (!disableEdit) {
                <button class="btn btn-sm btn-primary mr-2" [disabled]="isAnyInputRequired()" (click)="saveEdit()">
                    <fa-icon [icon]="['fas', 'save']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Save' | translate }}
                </button>
            }
            @if (!disableEdit) {
                <button class="btn btn-sm btn-danger" [disabled]="!allowedAdditionalData" (click)="cancelEdit()">
                    <fa-icon [icon]="['fas', 'times']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Cancel' | translate }}
                </button>
            }
        </div>
    }
    @if (additionalData.length > 0) {
        <div class="card-body">
            @for (data of additionalData; track data) {
                <div class="mt-3">
                    <app-additional-data-input
                        #additionalDataInputs
                        [name]="data.dataName"
                        [disabled]="disableEdit"
                        [mandatory]="data.dataType === 'M'"
                        [dataType]="data.editor"
                        [dataFormat]="data.dataFormatType.toLowerCase()"
                        [defaultValue]="StringToOther(data.dataValue, data.editor)"
                        [dataId]="data.dataId"></app-additional-data-input>
                </div>
            }
        </div>
    }
</div>
